// extracted by mini-css-extract-plugin
export default {"statsDropdownSelector":"StatsDropdownSelector_statsDropdownSelector__VrENN","statsDropdownSelector--highlighted":"StatsDropdownSelector_statsDropdownSelector--highlighted__dwWls"};